import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CommonService } from "src/app/shared/services/common-service";
import { environment } from "src/environments/environment";
import { Observable } from 'rxjs';
import { catchError } from "rxjs/operators";
import { MedicalCareSadtFileResponse } from "../../responses/medical-record/medical-care-sadt-file.response";

@Injectable({
  providedIn: 'root'
})
export class MedicalCareSadtFileService extends CommonService {

  constructor(private router: Router, private httpClient: HttpClient) {
    super();
  }

  public getMedicalCareSadtFile(idSadtResultFile:number): Observable<MedicalCareSadtFileResponse> {
    let uri = `MedicalCareSadtFile/idSadtResultFile/${idSadtResultFile}`

    return this.httpClient.get<MedicalCareSadtFileResponse>(environment.urlApiMedicalRecord + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }
}